import { apolloSpaceInset1X, apolloSpaceInset3X } from "@nexthink/apollo-tokens";
import React from "react";
import styled from "styled-components";
import useStatusColor from "../../hooks/useStatusColor";
const commonPreviewCssProps = {
    display: "inline-block",
    verticalAlign: "top",
    position: "absolute",
    left: 0,
    top: "50%",
    transform: "translateY(-50%)",
};
export const StyledSelectPreview = styled.div.withConfig({ displayName: "StyledSelectPreview_APC-7311-productShell", componentId: "sc-f7zvah" })(({ theme }) => (Object.assign({ backgroundColor: "white", border: `1px solid ${theme.colors.apolloColorStrokeFormElementDefault}`, borderRadius: 2, padding: 1, boxSizing: "border-box", marginRight: apolloSpaceInset1X }, commonPreviewCssProps)));
const StyledSelectPreviewColor = styled.div.withConfig({ displayName: "StyledSelectPreviewColor_APC-7311-productShell", componentId: "sc-r9tozj" })(({ color }) => ({
    width: 12,
    height: 12,
    backgroundColor: color,
    borderRadius: 1,
}));
const StyledText = styled.span.withConfig({ displayName: "StyledText_APC-7311-productShell", componentId: "sc-1qfyo2d" })(({ hasPadding }) => (Object.assign({}, (hasPadding && {
    marginLeft: apolloSpaceInset3X,
}))));
const SelectPreviewBlock = ({ status }) => {
    const { color } = useStatusColor(status);
    return (React.createElement(StyledSelectPreview, { role: "note", "aria-label": `preview: ${status}` },
        React.createElement(StyledSelectPreviewColor, { color: color })));
};
const SelectPreview = ({ status, children }) => (React.createElement(React.Fragment, null,
    status ? React.createElement(SelectPreviewBlock, { status: status }) : null,
    status ? React.createElement(StyledText, { hasPadding: true }, children) : children));
export default SelectPreview;
//# sourceMappingURL=SelectPreview.js.map